<!-- Manufacturer Name -->
<div class="row pt-2 pb-2 bg-white">
    <div class="col-11">
      <span class="text-muted fw-bold">Enter New Manufacturer Name</span>

      <input type="text" class="form-control mt-2" id="mfg_name" maxlength="50" placeholder="E.g. PepsiCo" [(ngModel)]="mfgName">
    </div>
    <div class="col-1 mt-4">
        <button class="btn btn-secondary float-end mt-2" [disabled]="currentAction" (click)="manageManufacturer()">Add</button>
    </div>
  </div>

<!-- Display manufacturers -->
<div class="row pt-2 pb-2 m-1 bg-white">
    <!-- Loading -->
    <div class="col-12 text-center" *ngIf="currentAction == 'getManufacturers'">
        <div class="spinner-border text-info mt-4" role="status"></div>
    </div>

    <!-- Manufacturer list -->
    <div class="col-12 border" *ngIf="currentAction == ''">
        <!-- Header -->
        <div class="row grid-row border-bottom mt-2">
            <div class="col-12 grid-title">Manufacturers</div>
        </div>

        <div class="row grid-row border-bottom border-light mt-2" *ngFor="let manufacturer of manufacturers">
            <div class="col-12 grid-item">{{ manufacturer.mfg_name }}</div>
        </div>
    </div>
</div>